module.exports = __webpack_public_path__ + "static/media/bfile-403b.3a09654d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-403b.svg
// module id = 566
// module chunks = 0